import * as z from 'zod';

import { tcCategoryQueryLinkerSchema } from '@/_pages/settings/terms-categories/shared/schemas';
import { paginatedResponseSchema } from '@/_schemas/generic/paginated-response';
import { statusQuerySchema } from '@/_schemas/status-input';

import { tcConditionQueryLinkerSchema } from './tc-condition-query-link-schema';

export const tcConditionQuerySchema = z.object({
  ...tcConditionQueryLinkerSchema.shape,
  sku: z.string(),
  notes: z.string().nullable(),
  term: z.string().nullable(),
  status: statusQuerySchema,
  category_id: z.number(),
  terms_condition_category: tcCategoryQueryLinkerSchema,
});

export type TcConditionQuerySchema = z.infer<typeof tcConditionQuerySchema>;

export const tcConditionQueryAllSchema = paginatedResponseSchema(tcConditionQuerySchema);

export type TcConditionQueryAllSchema = z.infer<typeof tcConditionQueryAllSchema>;
